<template>
  <div class="chat_container">
    <div class="navbar">
      <van-nav-bar :title="fromUser.name" left-arrow @click-left="onClickLeft" />
    </div>
    <div id="chatbigbox" ref="chatbigbox" el="chatbigbox">
      <div>
        <div v-if="page<pageCount - 1" @click="moreWxchatLists" class="morebtn">查看更多消息</div>
        <!-- 默认展示 -->
        <div v-if="page === pageCount - 1" class="chat-content-list-time">{{wxchatLists[0]?wxchatLists[0].ctime:'8:00'}}</div>
        <div v-if="wxchatLists.length == 0" class="chat-content-list-time">{{normalDataTime}}</div>
        <div v-if="page === pageCount - 1 || wxchatLists.length == 0" class="chat-content-list">
          <img class="chat-content-list-avatar" :src="fromUser.avatar_url" />
          <div class="chat-content-list-content">
            <div class="chat-content-list-msg">
              <span selectable="true">您好！我是{{fromUser.job_title}}- {{fromUser.name}}，欢迎进入我的名片， 有什么可以帮到您的吗？您可以在这里跟我实时沟通!</span>

              <div>
                <div id="message-shuoming">通过我的名片您还可以:</div>

                <div class="message-morenbox" id="message-morenbox">
                  <div class="message-mrxxlist" :data-id="fromUser.id" @click="gotocard">
                    <div class="message-mrxximg">
                      <img :src="communicationIconMp" />
                    </div>
                    <div class="message-mrxxtext">进入我的名片</div>
                    <div class="message-mrxxicon">
                      <img :src="homeIconEnter" />
                    </div>
                  </div>

                  <div v-if="fromUser.is_tel_show == 1 " class="message-mrxxlist" @click="callphone" :data-phonenum="fromUser.tel">
                    <div class="message-mrxximg">
                      <img :src="communicationIconPhone" style="width:1.027027027027027rem ;" />
                    </div>
                    <div class="message-mrxxtext">拨打我的电话</div>
                    <div class="message-mrxxicon">
                      <img :src="homeIconEnter" />
                    </div>
                  </div>

                  <div v-if="fromUser.wx_no" class="message-mrxxlist" data-target="Image" :data-wxqcode="fromUser.qr_code" @click="showModals">
                    <div class="message-mrxximg">
                      <img :src="communicationIconWx" style="width:1.2432432432432432rem " />
                    </div>
                    <div class="message-mrxxtext">添加我的微信</div>
                    <div class="message-mrxxicon">
                      <img :src="homeIconEnter" />
                    </div>
                  </div>
                  <div v-if="company_info.location" class="message-mrxxlist" @click="gotoadress">
                    <div class="message-mrxximg">
                      <img :src="communicationIconAd" style="width:0.8918918918918919rem;" />
                    </div>
                    <div class="message-mrxxtext">查看我的地址</div>
                    <div class="message-mrxxicon">
                      <img :src="homeIconEnter" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-for="(item,index) in wxchatLists" :key="index">
          <div class="chat-content-list-time">{{item.ctime}}</div>
          <div class="chat-content-list left" v-if="item.from_uid == chatid">
            <img class="chat-content-list-avatar" :src="fromUser.avatar_url" />
            <div class="chat-content-list-content">
              <!--  文字信息模板  ↓ hidden="{{!(item.msg_type === 'text')}}" -->
              <div class="chat-content-list-msg" v-if="item.msg_type === '0'">
                <span selectable="true">{{item.msg}}</span>
                <div class="over-read-tip"></div>
              </div>

              <!--  语音信息模板  ↓   hidden="{{!(item.msg_type === 'voice')}}" -->
              <div class="chat-content-list-voice" :class="(item.voiceTime<10?'length1':'length3')" @click="playRecord" v-if="item.msg_type === 'voice'">
                <span class>{{item.voiceTime}}s</span>
                <img class="chat-voice-img" :src="chatVoiceImg" />
                <div class="over-read-tip"></div>
              </div>

              <!--  图片信息模板  ↓   -->
              <div class="chat-content-list-img" v-if="item.msg_type === '1'">
                <img :src="item.msg" @click="seeBigImg" :data-msg="item.msg" :data-index="index" />
                <div class="over-read-tip"></div>
              </div>
            </div>
          </div>

          <div class="chat-content-list right" v-if="item.from_uid === ownDetailmsg.id">
            <img v-if="fromUser.avatar_url" class="chat-content-list-avatar" :src="ownDetailmsg.avatar_url" />
            <img v-else class="chat-content-list-avatar" :src="ownDetailmsg.wx_avatar" />
            <div class="chat-content-list-content">
              <div class="chat-content-list-msg" :hidden="!(item.msg_type === '0')">
                <span selectable="true">{{item.msg}}</span>
                <div class="over-read-tip"></div>
              </div>

              <div class="chat-content-list-voice" :class="(item.voiceTime<10?'length1':'length3')" @click="playRecord" :hidden="!(item.msg_type === 'voice')">
                <span>{{item.voiceTime}}s</span>
                <img class="chat-voice-img" :src="chatVoiceImg" />
                <div class="over-read-tip"></div>
              </div>

              <div class="chat-content-list-img" :hidden="!(item.msg_type === '1')">
                <img :src="item.msg" @click="seeBigImg" :data-msg="item.msg" />
              </div>
            </div>
          </div>
        </div>

        <!--弹出二维码-->
        <div class="cu-modal" :class="(modalName=='Image'?'show':'')">
          <div class="cu-dialog cu-dialog02">
            <img class="cu-avatar componts-close-btn" @click="hideModal" src="http://www.wodegame.com/tg/xianpipa/images/home_icon_close.png" alt />
            <div class="compons-modals-title flex align-center">
              <img class="cu-avatar radius lg weixin-img" :src="fromUser.wx_avatar?fromUser.wx_avatar:fromUser.avatar_url" alt />
              <div class="image-top-message">
                <div class="wexin-topname">{{fromUser.wx_nickname?fromUser.wx_nickname:fromUser.name}}</div>
                <div class="wexin-toparea" v-if="fromUser.province">{{fromUser.province}} {{fromUser.city}}</div>
              </div>
            </div>
            <img class="modal-qcode-img" :src="fromUser.qr_code" onclick="return false" />
            <div class="cu-bar">
              <div class="action margin-0 flex-sub solid-left">
                微信号：{{fromUser.wx_no}}
                <button class="cu-btn round bg-green button-hover ewmclonebtn" v-clipboard:copy="fromUser.wx_no" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input id="upload_file" ref="upload_file" type="file" style="display: none;" accept="image/*" name="file" @change="fileChange($event)" />
    <div name="chat-input">
      <div class="input-flex-column" id="input-flex-column" ref="inputflexcolumn" catchtap="null">
        <div class="input-text-voice-super">
          <div v-if="showVoicePart">
            <img class="extra-btn-style extra-btn-extrastyle" :src="communicationIconPic" @click="chatInputExtraClickEvent" />

            <div v-if="inputObj.inputStatus==='voice'">
              <!--   <template is="voice" data="{{voiceObj:inputObj.voiceObj,canUsePress:inputObj.canUsePress,imageUrl}}" /> -->
            </div>
          </div>
          <!--  <input v-if="inputObj.inputStatus==='text'"
                   class="chat-input-style" :style="{'margin-left':(showVoicePart?0:16px)}"
          maxlength="500" confirm-type="send" v-model="textMessage" bindconfirm="chatInputSendTextMessage" bindfocus="chatInputBindFocusEvent" bindblur="chatInputBindBlurEvent" bindinput="chatInputGetValueEvent" placeholder='想和TA说点什么呢？' cursor-spacing='20'/>-->
          <input type="text" class="chat-input-style" placeholder="想和TA说点什么呢？" v-model="textMessage" @keyup.enter="chatInputSendTextMessage02" @focus="chatInputfocus" />
          <div hover-class="press-style-opacity">
            <div class="chat-input-send-button-style" @click="chatInputSendTextMessage02">发送</div>
          </div>
        </div>
        <div v-if="chatInputShowExtra">
          <div class="list-divide-line"></div>
          <div class="extra-super">
            <div v-for="(item,index) in extraArr" :key="index" class="flex-column" style="width: 25%" @click="fileClick()" :data-index="index">
              <img class="extra-image-size" :src="require('../../assets/images/chat/extra/'+item.picName+'.png')" />
              <span class="extra-text-size">{{item.description}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  getWxchatLists,
  subPrivateLetters,
  getindexcartMsg,
  cartDetailMsg
} from "../../api/api";
import Vue from "vue";
import { Toast, Dialog, ImagePreview } from "vant";
import { mapState } from "vuex";
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ImagePreview);
import navbar from "../public/navbar.vue";

export default {
  name: "chat",
  components: { navbar },
  data () {
    return {
      chatInputShowExtra: false,
      extraArr: [
        {
          picName: "choose_picture",
          description: "照片"
        },
        {
          picName: "take_photos",
          description: "拍照"
        }
      ],
      modalName: "",
      titlename: "",
      chatid: "",
      wxchatLists: [],
      textMessage: "",
      chatItems: [],
      scrollTopTimeStamp: 0,
      height: 0, //屏幕高度
      chatHeight: 0, //聊天屏幕高度
      normalDataTime: "08:00",
      voiceSrc: "", //录音的路径
      chatgoheight: 520,
      contents: "这是可以复制的文字,粘贴后即可看到效果",
      fromUser: {
        avatar_url:
          "https://api.xianpipa.com/uploads/avatars/avatar_156591813897994898.png",
        city: "Xiamen",
        id: 6,
        job_title: "命令你寇敏",
        name: "枇杷",
        province: "Fujian",
        qr_code:
          "https://api.xianpipa.com/uploads/qrcodes/20190808/qrcode_156525448957505097.png",
        tel: "13860646465",
        wx_avatar:
          "https://wx.qlogo.cn/mmopen/vi_32/pSRTJsVK3V9IUNic4Kq9IEDmxIX8B8guhskicVr8gIXLTVuhbiac2cp6vLkzNhuicfZoL5W53Hibq8DN8eicr3ibB103g/132",
        wx_nickname: "枇杷",
        wx_no: "N10245685"
      },
      ownDetailmsg: {
        apple_qrcode: "https://api.xianpipa.com/images/default/qrcode.jpg",
        avatar_url:
          "https://api.xianpipa.com/uploads/avatars/avatar_156644304149575555.png",
        bg_url: "https://api.xianpipa.com/images/template/head/tou1.jpg",
        city: "泉州",
        id: "15",
        is_first_login: 0,
        is_nice: 0,
        job_title: "前端工程师",
        msg_num: "0",
        name: "庄萍萍",
        nices_num: "1",
        province: "福建",
        qr_code:
          "https://api.xianpipa.com/uploads/qrcodes/20190808/qrcode_156525448957505097.png",
        reg_status: "1",
        remark: "",
        tel: "15959963929",
        voice_len: "4",
        voice_remark:
          "https://api.xianpipa.com/uploads/voices/20190820/wxd1ff26c8d7d53aac.o6zAJs26teikyXaIkDDHonPwG6x8.oLCdx6Nyw2kN6491667b2077b1f1b045146bf7258e40.durationTime=3579.mp3",
        wx_avatar:
          "https://wx.qlogo.cn/mmopen/vi_32/kgyGcDgRGlVicet5dbUozkh5vogWFqE2yXEBwb0hltKolheDaOxB64JAOeib0VbqULGwfzWFmWUZLp7t4TicWfntA/0",
        wx_nickname: "Small呆又呆ヽ(`Д´)ﾉ",
        wx_no: "a11111111"
      }, //自己的信息
      page: 0,
      pageCount: 1,
      company_info: {},
      datas: new FormData(),
      files: 0,
      firstEnter: false,
      homeIconEnter: require("../../assets/images/home_icon_enter.png"),
      communicationIconPic: require("../../assets/images/communication_icon_pic.png"),
      communicationIconMp: require("../../assets/images/communication_icon_mp.png"),
      communicationIconPhone: require("../../assets/images/communication_icon_phone.png"),
      communicationIconWx: require("../../assets/images/communication_icon_wx.png"),
      communicationIconAd: require("../../assets/images/communication_icon_ad.png"),
      chatVoiceImg: require("../../assets/images/chat-voice-img@3x.png")
    };
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == "othercart" || from.name == "address") {
      // 这个name是下一级页面的路由name
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
  beforeRouteLeave (to, from, next) {
    if (to.name == "othercart" || to.name == "address") {
      // 这个name是下一级页面的路由name
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  watch: {
    $route: function (to, from) {
      if (to.name == "cartbox") {
        //后退，tree 0为A页面，1为B页面，2为C页面
        this.firstEnter = true;
      }
    }
  },
  activated () {
    if (this.firstEnter) {
      this.firstEnter = false;
      // 清空原有数据
      let that = this;
      let normalDataTime = this.formatTime(new Date());
      this.normalDataTime = this.getTimeText(normalDataTime);
      let id = this.$route.query.id;
      this.initCartMsg(id);
      this.initOwnCartMsg();

      let json = {
        page: 0
      };
      getWxchatLists(json, id).then(res => {
        if (res) {
          if (res.data.code == 200) {
            //200-已注册
            let wxchatLists = res.data.data.list;
            wxchatLists.filter(item => {
              if (item.ctime) {
                item.ctime = that.getTimeText(item.ctime);
              }
            });
            this.fromUser = res.data.data.fromUser;
            this.wxchatLists = wxchatLists;
            this.page = res.data.data.pageCount - 1;
            this.pageCount = res.data.data.pageCount; //有聊天记录时设置页面高度
            for (var i = 1; i < res.data.data.pageCount; i++) {
              this.page = i;
              this.uploadWxchatLists();
            }
          }
        }
      });
    }
  },
  created () {
    document.title = "与" + this.$route.query.chatname + "会话";
    this.titlename = this.$route.query.chatname;
    this.chatid = this.$route.query.id;
    let normalDataTime = this.formatTime(new Date());
    this.normalDataTime = this.getTimeText(normalDataTime);
    let id = this.$route.query.id;
    this.initCartMsg(id);
    this.initOwnCartMsg();
    this.initWxchatLists(id);
  },
  mounted () {
    this.scrollToBottom();
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1);
    },
    //时间戳 转yyyy-mm-dd hh:mm:ss时间格式
    formatTime (dates) {
      const date = new Date(dates);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      return (
        [year, month, day].map(this.formatNumber).join("-") +
        " " +
        [hour, minute, second].map(this.formatNumber).join(":")
      );
    },
    //补0
    formatNumber (n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    // 时间统一函数
    getTimeText (argument) {
      var timeS = argument;
      var todayT = "";
      var yestodayT = "";
      var lastyearT = "";
      var timeCha = this.getTimeS(timeS);
      var pre = new Date();
      pre.setFullYear(pre.getFullYear() - 1);
      pre = this.getTimeS(pre);
      timeS = timeS.slice(-8);
      todayT =
        new Date().getHours() * 60 * 60 * 1000 +
        new Date().getMinutes() * 60 * 1000 +
        new Date().getSeconds() * 1000;
      yestodayT = todayT + 24 * 60 * 60 * 1000;
      argument.replace(/-/g, "/");
      //大于一年
      if (timeCha > pre) {
        return argument.slice(2, 11);
      }
      //大于昨天
      if (timeCha > yestodayT) {
        return argument.slice(5, 11);
      }
      //昨天
      if (timeCha > todayT && timeCha < yestodayT) {
        return "昨天" + timeS.slice(0, 5);
      }
      //今天
      if (timeCha < todayT) {
        return timeS.slice(0, 5);
      }
    },
    // 时间戳获取
    getTimeS (argument) {
      var timeS = argument;
      return new Date().getTime() - new Date(timeS).getTime() - 1000; //有一秒的误差
    },
    //获取聊天列表
    initWxchatLists (id) {
      let that = this;
      let json = {
        page: 0
      };
      getWxchatLists(json, id).then(res => {
        if (res) {
          if (res.data.code == 200) {
            //200-已注册
            let wxchatLists = res.data.data.list;
            wxchatLists.filter(item => {
              if (item.ctime) {
                item.ctime = that.getTimeText(item.ctime);
              }
            });
            this.fromUser = res.data.data.fromUser;
            this.wxchatLists = wxchatLists;
            this.pageCount = res.data.data.pageCount;

            //有聊天记录时设置页面高度
            this.scrollToBottom();
          }
        }
      });
    },
    //加载更多聊天列表
    uploadWxchatLists () {
      let that = this;
      let id = this.$route.query.id;
      let json = {
        psge: that.page
      };
      getWxchatLists(json, id).then(res => {
        if (res) {
          if (res.data.code == 200) {
            Toast.clear();
            let tpmData = res.data.data.list;
            tpmData.filter(item => {
              if (item.ctime) {
                item.ctime = that.getTimeText(item.ctime);
              }
            });
            let oldtpmData = that.wxchatLists;
            oldtpmData = tpmData.concat(oldtpmData);
            that.wxchatLists = oldtpmData;
          }
        }
      });
    },
    //获取自己的信息
    initOwnCartMsg () {
      getindexcartMsg().then(res => {
        if (res) {
          if (res.data.code == 200) {
            //200-已注册
            this.ownDetailmsg = res.data.data;
          }
        }
      });
    },
    //获取对方信息--地址
    initCartMsg (id) {
      cartDetailMsg(id).then(res => {
        if (res) {
          if (res.data.code == 200) {
            //200-已注册
            this.chatid = res.data.data.id;
            this.company_info = res.data.data.company_info;
          }
        }
      });
    },
    gotocard: function (e) {
      this.$router.push({
        name: "othercart",
        query: {
          id: e.currentTarget.dataset.id
        }
      });
    },
    callphone: function (e) {
      let that = this;
      let phonenum = e.currentTarget.dataset.phonenum;
      Dialog.confirm({
        message: "拨打" + phonenum + "？"
      })
        .then(() => {
          // on confirm
          window.location.href = "tel:" + phonenum;
        })
        .catch(() => {
          // on cancel
        });
    },
    showModals: function (e) {
      let mtype = e.currentTarget.dataset.target;
      let wxqcodeimg = e.currentTarget.dataset.wxqcode;
      if (wxqcodeimg != "") {
        this.modalName = mtype;
      } else {
        this.modalName = "";
        this.$copyText(this.fromUser.wx_no).then(
          function (e) {
            Toast.success({
              duration: 2000,
              message: "复制成功"
            });
          },
          function (e) {
            Toast.fail({
              duration: 2000,
              message: "复制失败"
            });
          }
        );
      }
    },
    gotoadress: function () {
      this.$router.push({
        name: "address",
        params: {
          companyData: this.company_info
        }
      });
    },
    playRecord: function () { },
    seeBigImg: function (e) {
      let avaimg = e.currentTarget.dataset.msg;
      let avaimgObg = [];
      avaimgObg.push(avaimg);
      ImagePreview({
        images: avaimgObg,
        showIndex: false
      });
    },
    hideModal: function () {
      this.modalName = "";
    },
    showVoicePart: function () { },
    chatInputSendTextMessage02: function () {
      var formjson = {
        to_uid: this.chatid,
        msg: this.textMessage,
        msg_type: "0"
      };
      subPrivateLetters(formjson).then(res => {
        if (res.code == 200) {
          this.initWxchatLists(this.chatid);
        }
      });
      this.textMessage = "";
      this.scrollToBottom();
    },
    scrollToBottom () {
      this.$nextTick(() => {
        var container = this.$el.querySelector("#chatbigbox");
        window.scrollTo(0, container.scrollHeight);
      });
    },
    inputObj: function () { },
    // 复制成功
    onCopy (e) {
      Toast.success({
        duration: 2000,
        message: "复制成功"
      });
    },
    // 复制失败
    onError (e) {
      alert("失败");
    },
    extraItemEvent: function (e) { },
    chatInputExtraClickEvent: function () {
      this.chatInputShowExtra = !this.chatInputShowExtra;
      var container = this.$el.querySelector("#chatbigbox");
      if (this.chatInputShowExtra) {
        container.style.paddingBottom = "192px";
      } else {
        container.style.paddingBottom = "60px";
      }
      this.scrollToBottom();
    },
    //关闭
    chatInputExtraClose: function () {
      this.chatInputShowExtra = false;
      var container = this.$el.querySelector("#chatbigbox");
      container.style.paddingBottom = "60px";
      this.scrollToBottom();
    },
    chatInputfocus: function () {
      this.chatInputExtraClose();
    },
    //调用相册&相机
    fileClick () {
      this.$refs.upload_file.click();
    },

    fileChange (el) {
      this.files = this.$refs.upload_file.files[0].name;
      for (let i = 0; i < this.files.length; i++) {
        this.datas.append("file", this.files[i]);
      }
      this.show1 = false;
      if (!el.target.files[0].size) return;
      this.fileList(el.target);
      el.target.value = "";
    },
    fileList (fileList) {
      let files = fileList.files;
      for (let i = 0; i < files.length; i++) {
        //判断是否为文件夹
        if (files[i].type != "") {
          this.fileAdd(files[i]);
        } else {
          //文件夹处理
          this.folders(fileList.items[i]);
        }
      }
    },
    //文件夹处理
    folders (files) {
      let _this = this;
      //判断是否为原生file
      if (files.kind) {
        files = files.webkitGetAsEntry();
      }
      files.createReader().readEntries(function (file) {
        for (let i = 0; i < file.length; i++) {
          if (file[i].isFile) {
            _this.foldersAdd(file[i]);
          } else {
            _this.folders(file[i]);
          }
        }
      });
    },
    fileAdd (file) {
      var that = this;
      //判断是否为图片文件
      if (file.type.indexOf("image") != -1) {
        let reader = new FileReader();
        reader.vue = this;
        reader.readAsDataURL(file);
        reader.onload = function () {
          file.src = this.result;

          var img = new Image();

          img.onload = function () {
            // 当图片宽度超过 400px 时, 就压缩成 400px, 高度按比例计算
            // 压缩质量可以根据实际情况调整
            var w = Math.min(250, img.width);
            var h = img.height * (w / img.width);
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");

            // 设置 canvas 的宽度和高度
            canvas.width = w;
            canvas.height = h;

            // 把图片绘制到 canvas 中
            ctx.drawImage(img, 0, 0, w, h);

            // 取出 base64 格式数据
            var dataURL = canvas.toDataURL("image/png");
            var base64String = dataURL;
            //这里对base64串进行操作，去掉url头，并转换为byte
            var bytes = window.atob(base64String.split(",")[1]);

            //处理异常，将ASCII码小于0的转换为大于0，这里有两种写法

            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
              ia[i] = bytes.charCodeAt(i); //这里有点疑惑，ia是怎么改变ab的？注：①
            }
            //Blob对象
            var blob = new Blob([ab], { type: "image/jpeg" }); //type为图片的格式

            //FormData对象
            var formData = new FormData();

            formData.append("file", blob, Date.now() + ".jpg");
            formData.append("type", "chat");

            let baseURL = that.baseAPI;
            axios.defaults.headers.common["PLATFORM"] = "H5";
            axios.defaults.timeout = 30000;
            //上传
            const instance = axios.create({
              withCredentials: false
            });
            instance
              .post(baseURL + "/file-bases/images", formData)
              .then(res => {
                var formjson = {
                  to_uid: that.chatid,
                  msg: res.data.data.url,
                  msg_type: "1"
                };
                subPrivateLetters(formjson).then(res => {
                  if (res.code == 200) {
                    that.initWxchatLists(that.chatid);
                  }
                });
                that.chatInputExtraClickEvent();
                that.scrollToBottom();
              })
              .catch(function (error) {
              });
            // ...
          };

          img.src = this.result;
        };
      }
    },
    dragenter (el) {
      el.stopPropagation();
      el.preventDefault();
    },
    dragover (el) {
      el.stopPropagation();
      el.preventDefault();
    },
    drop (el) {
      el.stopPropagation();
      el.preventDefault();
      this.fileList(el.dataTransfer);
    },
    shows (et, tx) {
      this.strut = et;
      this.txt = tx;
    },
    handleClick () {
      this.$store.commit("add");
    },
    moreWxchatLists () {
      var page = this.page;
      var pageCount = this.pageCount;
      page++;
      if (page > pageCount) {
        return;
      }
      this.page = page;
      Toast.loading({
        mask: false,
        message: "加载中..."
      });
      this.uploadWxchatLists();
    }
  }
};
</script>

<style scoped>
.van-nav-bar {
  height: 50px;
  line-height: 50px;
  position: fixed;
  width: 100%;
  border-bottom: 1px solid #eee;
}
.van-nav-bar__title {
  font-weight: bold;
  font-size: 0.8rem;
}
.van-icon-arrow-left:before {
  color: #333;
  font-size: 1rem;
}
.chat_container {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
}
/* pages/index/chat/chat.wxss */
@import "chat-input/chat-input.wxss";
@import "../../../css/model.wxss";
page {
  background-color: #f8f8f8;
}
div,
textarea,
input,
span {
  box-sizing: border-box;
}
#chatbigbox {
  background-color: #f8f8f8;
  padding-bottom: 3.2432432432432434rem;
  padding-top: 50px;
}
.chat {
  display: flex;
  flex-direction: column;
}
.chat-content {
  -webkit-overflow-scrolling: touch;
}
.chat-content > view:last-child {
  margin-bottom: 1.3513513513513513rem;
}
.chat-content-list {
  display: flex;
  align-items: flex-start;
  padding: 0 0.8108108108108109rem;
}
.chat-content-list.right {
  flex-direction: row-reverse;
}
.chat-content-list.right > .chat-content-list-avatar {
  margin-right: 0;
  margin-left: 0.8108108108108109rem;
}
.chat-content-list.right
  > .chat-content-list-content
  > .chat-content-list-name {
  margin-right: 0.43243243243243246rem;
  text-align: right;
}
.chat-content-list.right > .chat-content-list-content .chat-content-list-msg {
  margin-left: 0;
  background: #f9b30b;
  color: #fff;
}
.chat-content-list-voice {
  padding: 0 0 0 1.0810810810810811rem;
  box-sizing: border-box;
  border-top-left-radius: 1.162162162162162rem;
  border-top-right-radius: 1.162162162162162rem;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 1.162162162162162rem;
  background-color: #f9b30b;
  font-size: 0.8648648648648649rem;
  color: #fff;
  position: relative;
  min-width: 5.405405405405405rem;
  max-width: 8.972972972972974rem;
  line-height: 2.324324324324324rem;
  font-weight: 300;
  height: 2.324324324324324rem;
}
.chat-content-list-voice.length1 {
  width: 5.405405405405405rem;
}
.chat-content-list-voice.length2 {
  width: 7.081081081081081rem;
}
.chat-content-list-voice.length3 {
  width: 8.972972972972974rem;
}
/*声音语音*/
.chat-voice-img {
  width: 1.4054054054054055rem;
  height: 0.8108108108108109rem;
  float: right;
  margin-right: 1.0810810810810811rem;
  margin-top: 0.7567567567567568rem;
}
.chat-content-list-avatar {
  width: 2.3783783783783785rem;
  height: 2.3783783783783785rem;
  margin-right: 0.8108108108108109rem;
  border-radius: 50%;
}
.chat-content-list-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 2.324324324324324rem;
  max-width: 12.54054054054054rem;
  line-height: 1.6;
  position: relative;
}
.chat-content-list.right .chat-content-list-content {
  align-items: flex-end;
}
.chat-content-list-msg.yellow {
  background: #ffdb0e;
}
.chat-content-list-name {
  margin-left: 0.43243243243243246rem;
  font-family: MicrosoftYaHei;
  font-size: 0.6486486486486487rem;
  color: #1e1e1e;
  margin-bottom: 0.16216216216216217rem;
}
.chat-content-list-msg {
  padding: 0.43243243243243246rem 0.6756756756756757rem;
  border-top-left-radius: 1.162162162162162rem;
  border-top-right-radius: 1.162162162162162rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 1.162162162162162rem;
  background-color: #fff;
  color: #1e1e1e;
  position: relative;
  max-width: 14.594594594594595rem;
  word-wrap: break-word;
  font-size: 0.8108108108108109rem;
  font-weight: 400;
  box-shadow: 0rem 0rem 0.08108108108108109rem #ddd;
}
.chat-content-list .chat-content-list-msg {
  border-radius: 0.40540540540540543rem;
  position: relative;
}
.chat-content-list .chat-content-list-msg::after {
  content: "";
  top: 0.7297297297297297rem;
  transform: rotate(45deg);
  position: absolute;
  display: inline-block;
  overflow: hidden;
  width: 0.6486486486486487rem;
  height: 0.6486486486486487rem;
  left: -0.32432432432432434rem;
  right: initial;
  background-color: inherit;
}
.chat-content-list.right .chat-content-list-msg::after {
  left: auto;
  right: -0.32432432432432434rem;
}
.chat-set {
  width: 20.27027027027027rem;
  height: 2.6486486486486487rem;
  background-color: #f7f7fa;
  border-top: 0.05405405405405406rem solid rgba(0, 0, 0, 0.2);
  padding: 0 0.6486486486486487rem;
  position: relative;
}
.chat-set-icon {
  width: 1.6216216216216217rem;
  height: 1.6216216216216217rem;
}
.chat-set-icon-right {
  margin-left: 0.6486486486486487rem;
}
.chat-set-input {
  width: 14.324324324324325rem;
  height: 1.945945945945946rem;
  border-radius: 0.2702702702702703rem;
  background-color: #fff;
  border: solid 2px rgba(0, 0, 0, 0.2);
  margin-left: 0.6486486486486487rem;
  padding-left: 0.2702702702702703rem;
  padding-right: 0.2702702702702703rem;
  padding-top: 0.2702702702702703rem;
  padding-bottom: 0.2702702702702703rem;
  font-size: 0.6486486486486487rem;
  line-height: 0.8648648648648649rem;
}
.chat-set-voice {
  width: 14.324324324324325rem;
  height: 1.945945945945946rem;
  border-radius: 0.2702702702702703rem;
  border: solid 2px rgba(0, 0, 0, 0.2);
  line-height: 1.945945945945946rem;
  font-size: 0.6486486486486487rem;
  color: #333;
  text-align: center;
  margin-left: 0.6486486486486487rem;
}
.chat-set-write {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.chat-emoji {
  position: absolute;
  width: 20.27027027027027rem;
  bottom: 2.6486486486486487rem;
  left: 0;
}
.chat-emoji-list {
  display: inline-flex;
  flex-flow: wrap;
}
.chat-emoji-icon {
  width: 1.2432432432432432rem;
  height: 1.2432432432432432rem;
  padding: 0.2702702702702703rem;
  border-radius: 0.16216216216216217rem;
}
.chat-speaking {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  background: rgba(2, 2, 2, 0.6);
  z-index: 1000;
  width: 8.108108108108109rem;
  height: 8.108108108108109rem;
  border-radius: 0.2702702702702703rem;
}
.speaker {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 3.2432432432432434rem;
  height: 3.2432432432432434rem;
}
.chat-content-list-img {
  width: 11.891891891891891rem;
  height: auto;
  position: relative;
  overflow: hidden;
}
.chat-content-list-img img {
  width: 100%;
  height: 100%;
  border-radius: 0.40540540540540543rem;
}
.chat-content-list-time {
  display: block;
  text-align: center;
  width: 100%;
  height: 2.3783783783783785rem;
  font-size: 0.6486486486486487rem;
  color: #ccc;
  float: left;
  padding-top: 0.8108108108108109rem;
  box-sizing: border-box;
}
.over-read-tip {
  width: 0.32432432432432434rem;
  height: 0.32432432432432434rem;
  border-radius: 50%;
  background: #553a91;
  position: absolute;
  left: -1.0810810810810811rem;
  bottom: 0;
  display: none;
}
.over-read-tip.active {
  display: block;
}
#message-shuoming {
  clear: both;
  font-size: 0.7027027027027027rem;
  color: #999;
  padding-top: 0.5405405405405406rem;
  padding-bottom: 0.5405405405405406rem;
}
#message-morenbox .message-mrxxlist {
  border: 1px solid #eee;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  padding: 0.2702702702702703rem 0.2702702702702703rem;
  border-radius: 0.16216216216216217rem;
  margin-bottom: 0.43243243243243246rem;
}
#message-morenbox .message-mrxxlist .message-mrxximg {
  flex: 2;
  padding-top: 0.35135135135135137rem;
  padding-left: 0.40540540540540543rem;
}
#message-morenbox .message-mrxxlist .message-mrxximg img {
  height: 1.027027027027027rem;
}
#message-morenbox .message-mrxxlist .message-mrxxtext {
  flex: 8;
  padding-top: 0.16216216216216217rem;
  color: #666;
  padding-top: 0.21621621621621623rem;
  font-size: 0.7567567567567568rem;
}
#message-morenbox .message-mrxxlist .message-mrxxicon {
  padding-top: 0.2702702702702703rem;
  padding-right: 0.2702702702702703rem;
}
#message-morenbox .message-mrxxlist .message-mrxxicon img {
  width: 0.4594594594594595rem;
  height: 0.8648648648648649rem;
  flex: 2;
}
.cu-dialog02 {
  width: 15.135135135135135rem;
  height: 21.56756756756757rem;
}
.compons-modals-title {
  margin: 0.8108108108108109rem 1.6216216216216217rem 0.2702702702702703rem;
}
.ewnclosebtn {
  width: 1.6216216216216217rem;
  height: 1.6216216216216217rem;
  padding-top: 0.2702702702702703rem;
}
.ewnclosebtn img {
  width: 1.6216216216216217rem;
  height: 1.6216216216216217rem;
}
.ewmclonebtn {
  margin-left: 0.6756756756756757rem;
  position: relative;
  border: 0px;
  padding: 0 0.8108108108108109rem;
  font-size: 0.7567567567567568rem;
  height: 1.7297297297297298rem;
  line-height: 1;
  background-color: #39b54a;
  color: #fff;
  border-radius: 0.840541rem;
}

.wexin-topname {
  font-size: 0.918918918918919rem;
  color: #333;
  margin-bottom: 0.2702702702702703rem;
  width: 7.5675675675675675rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wexin-toparea {
  font-size: 0.7027027027027027rem;
  color: #666;
  width: 7.5675675675675675rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.morebtn {
  display: block;
  text-align: center;
  width: 100%;
  height: 1.6216216216216217rem;
  font-size: 0.6486486486486487rem;
  color: rgb(255, 189, 10);
  float: left;
  padding-top: 0.8108108108108109rem;
  box-sizing: border-box;
}

/*模态框开始 */
.login-model {
  width: 15.675675675675675rem;
  padding: 1.1081081081081081rem 0.972972972972973rem 1.135135135135135rem
    0.972972972972973rem;
}
.logo-img {
  width: 3.72972972972973rem;
  height: 3.72972972972973rem;
}
.login-tips {
  font-size: 0.918918918918919rem;
  line-height: 1.3513513513513513rem;
  color: #333333;
  margin: 1.135135135135135rem 0 1.0810810810810811rem 0;
}
.login-model-btn {
  width: 5.945945945945946rem;
  height: 2.1621621621621623rem;
  border-radius: 1.0810810810810811rem;
  color: #ffffff;
  background-image: linear-gradient(0deg, #ffbd0a, #f9da5b);
}
/*模态框结束 */
.inner-container {
  width: 85%;
  position: relative;
  margin: 4.054054054054054rem 0;
  background-color: lightcyan;
  border-top-left-radius: 1.6216216216216217rem;
  border-bottom-right-radius: 1.6216216216216217rem;
  overflow-y: auto;
}
.logo-messages {
  position: fixed;
  bottom: 4.054054054054054rem;
  right: 1.0810810810810811rem;
}
.userinfo {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}
.userinfo-avatar {
  width: 3.4594594594594597rem;
  height: 3.4594594594594597rem;
  margin: 0.5405405405405406rem;
  border-radius: 50%;
}
/* template/popub/popub.wxss */
/* 模态框 */
.compons-modals {
  position: relative;
}
.inner-compons-modals {
  width: 100%;
  height: 100%;
}
.componts-close-btn {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  position: absolute;
  top: 1.054054054054054rem;
  right: 1.027027027027027rem;
  background-color: transparent;
  z-index: 90;
}
.compons-modals-title {
  font-size: 0.918918918918919rem;
  color: rgb(51, 51, 51);
  font-weight: bold;
  margin-bottom: 0.8108108108108109rem;
  width: 10.81081081081081rem;
  letter-spacing: 0.05405405405405406rem;
}
.compons-modals-content {
  height: 14.864864864864865rem;
  font-size: 0.7567567567567568rem;
  line-height: 1.3513513513513513rem;
  color: #666666;
  text-align: left;
  overflow: auto;
}
.before-icons {
  display: inline-block;
  width: 0.16216216216216217rem;
  height: 0.8648648648648649rem;
  background-color: #ffbd0a;
  margin-right: 0.4864864864864865rem;
  margin-bottom: -0.13513513513513514rem;
}
/* img */
.image-top-message {
  text-align: left;
  margin-left: 0.8378378378378378rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.wexin-topname {
  font-size: 0.918918918918919rem;
  color: #333333;
  margin-bottom: 0.2702702702702703rem;
  font-weight: 550;
  font-family: "SimHei";
}
.wexin-toparea {
  font-size: 0.7027027027027027rem;
  color: #666666;
}
.lines-copys {
  font-size: 0.7567567567567568rem;
  padding: 0.6756756756756757rem 0;
}
.weixin-copy {
  display: inline-block;
  color: #6699ff;
  padding-left: 0.5945945945945946rem;
}
.modal-qcode-img {
  width: 14.35135135135135rem;
  height: 14.297297297297296rem;
}
.models-bottom-tips {
  font-size: 0.7027027027027027rem;
  color: #999999;
  margin-top: 0.5405405405405406rem;
}
/* swiper */
swiper {
  height: 14.378378378378379rem;
}
.slide-img {
  width: 100%;
  height: 100%;
}
.slide-icon {
  display: flex;
  justify-content: center;
}
.slide-icon .icon {
  width: 0.4594594594594595rem;
  height: 0.4594594594594595rem;
  background-color: #6599ff;
  border-radius: 50%;
  margin: 1.0810810810810811rem 0.2702702702702703rem 0;
}
.wx-swiper-dots {
  position: absolute;
}
.wx-swiper-dots.wx-swiper-dots-horizontal {
  bottom: -0.2702702702702703rem;
}
.icon-changeIndex {
  width: 1.4594594594594594rem;
  height: 1.4594594594594594rem;
  border-radius: 50%;
  position: absolute;
  top: 8.162162162162161rem;
  padding: 0.35135135135135137rem;
  z-index: 50;
}
.icon-clileft {
  left: 0;
}
.icon-cliright {
  right: 0;
}

/* ==================
         模态窗口
 ==================== */

.cu-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1110;
  opacity: 0;
  outline: 0;
  text-align: center;
  -ms-transform: scale(1.185);
  transform: scale(1.185);
  backface-visibility: hidden;
  perspective: 2000rpx;
  background: rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease-in-out 0s;
  pointer-events: none;
}

.cu-modal::before {
  content: "\200B";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.cu-modal.show {
  opacity: 1;
  transition-duration: 0.3s;
  -ms-transform: scale(1);
  transform: scale(1);
  overflow-x: hidden;
  overflow-y: auto;
  pointer-events: auto;
}

.cu-dialog {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: auto;
  margin-right: auto;
  width: 15.84rem;
  max-width: 100%;
  background-color: #f8f8f8;
  border-radius: 0.26rem;
  overflow: hidden;
}

.cu-modal.bottom-modal::before {
  vertical-align: bottom;
}

.cu-modal.bottom-modal .cu-dialog {
  width: 100%;
  border-radius: 0;
}

.cu-modal.bottom-modal {
  margin-bottom: -26.66rem;
}

.cu-modal.bottom-modal.show {
  margin-bottom: 0;
}

.cu-modal.drawer-modal {
  transform: scale(1);
  display: flex;
}

.cu-modal.drawer-modal .cu-dialog {
  height: 100%;
  min-width: 5.33rem;
  border-radius: 0;
  margin: initial;
  transition-duration: 0.3s;
}

.cu-modal.drawer-modal.justify-start .cu-dialog {
  transform: translateX(-100%);
}

.cu-modal.drawer-modal.justify-end .cu-dialog {
  transform: translateX(100%);
}

.cu-modal.drawer-modal.show .cu-dialog {
  transform: translateX(0%);
}
.cu-bar {
  display: flex;
  position: relative;
  align-items: center;
  min-height: 2.66rem;
  justify-content: space-between;
  transition: all 0.3s ease-in-out;
}
.cu-bar .action {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  max-width: 100%;
  color: #000;
  flex: 1;
  font-size: 0.8108108108108109rem;
}
.cu-avatar.lg {
  width: 2.5945945945945947rem;
  height: 2.5945945945945947rem;
  font-size: 2em;
  border-radius: 0.16216216216216217rem;
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}

/* @import "voice.wxss";
 */
@import "extra.wxss";
input {
  padding-top: 0.2702702702702703rem;
  padding-bottom: 0.2702702702702703rem;
  width: 100%;
}
.extra-btn-style {
  width: 1.5135135135135136rem;
  height: 1.5135135135135136rem;
  display: flex;
  flex-shrink: 0;
}
.extra-btn-extrastyle {
  margin-left: 0.8108108108108109rem;
  margin-right: 0.8108108108108109rem;
  height: 1.2432432432432432rem;
}
.input-text-voice-super {
  display: flex;
  flex-direction: row;
  background-color: white;
  width: 100%;
  align-items: center;
  height: 2.7027027027027026rem;
}
.input-flex-column {
  width: 100%;
  flex-direction: column;
  position: fixed;
  left: 0;
  bottom: 0;
  border-top: 0.02702702702702703rem solid #ebebeb;
}
.list-divide-line {
  width: 100%;
  height: 0.02702702702702703rem;
  background-color: #dddddd;
}
.chat-input-style {
  padding: 0.2702702702702703rem;
  height: 1.5135135135135136rem;
  line-height: 1;
  background-color: #fff;
  font-size: 0.8648648648648649rem;
  color: #1e1e1e;
  border: 0;
}
.chat-input-send-button-style {
  width: 3.5135135135135136rem;
  padding: 0.40540540540540543rem 0;
  font-size: 0.8108108108108109rem;
  text-align: center;
  margin: 0 0.2702702702702703rem;
  border-radius: 1.3513513513513513rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  color: #fff;
  margin-right: 0.5405405405405406rem;
}
.btn-voice-press {
  border: 1px solid #1e1e1e;
  background-color: #fff;
  border-radius: none;
}

.press-style {
  background-color: rgba(0, 0, 0, 0.1);
}
.press-style-opacity {
  opacity: 0.5;
}
.extra-super {
  display: flex;
  padding-top: 0.6756756756756757rem;
  height: 6.324324324324325rem;
  width: 100%;
  background-color: white;
  border-top: 0.02702702702702703rem solid #ebebeb;
}
.extra-image-size {
  width: 3.081081081081081rem;
  height: 3.081081081081081rem;
}
.extra-text-size {
  color: #666666;
  font-size: 0.6486486486486487rem;
  margin-top: 0.2702702702702703rem;
}
.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flex-row {
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/chat.vue